<div class="screens layout-spacing">
    <!-- The to be projected content into the subnavbar -->
    <ng-template #subNavBarContent>
        <ntv-button
            color="custom"
            customColor="#8DCB2C"
            size="xl"
            rounded="md"
            (click)="onCreateScreen()">
            <span class="text-white">
                <div class="main-btn text-white">
                    <span> Create Screen</span>

                    <svg width="14" height="14">
                        <use [attr.href]="spritePath + '#' + icons['ads']"></use>
                    </svg>
                </div>
            </span>
        </ntv-button>
    </ng-template>

    <div class="screens__stats">
        @for (screen of statsData(); track screen.title + $index) {
            <app-stats-card [statsData]="screen" [hasTotal]="true" width="100%"></app-stats-card>
        }
    </div>

    <div class="screens__table">
        <div class="screens__table-header">
            <app-table-toolbar
                [placeholder]="'Search Screen Name'"
                [buttons]="toolbarButtons()"
                (actionClick)="onToolbarAction($event)">
            </app-table-toolbar>
        </div>
        <div class="screens__table-body">
            <div class="screens__content-table">
                <app-table
                    [columns]="screensColumns"
                    [data]="screensData"
                    [tableTitle]="'Screens'"
                    [tableHeight]="'780px'"
                    [hasCheckBox]="true"
                    [paddingY]="'14px'"
                    [paddingX]="'15px'"
                    (actionClick)="onActionClick($event)"
                    (cellClick)="onCellClick($event)"
                    (selectionChange)="onSelectionChange($event)">
                </app-table>
            </div>
        </div>
    </div>
</div>
